"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableRows = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@dnd-kit/core");
var sortable_1 = require("@dnd-kit/sortable");
var modifiers_1 = require("@dnd-kit/modifiers");
var styles_1 = require("./styles");
var SortableItem_1 = require("./SortableItem");
var DraggableRows = function (_a) {
    var variant = _a.variant, _b = _a.onChangeValue, onChangeValue = _b === void 0 ? function (_selected, _orderedList) { } : _b, _c = _a.onInitialLoad, onInitialLoad = _c === void 0 ? function (_selected, _orderedList) { } : _c, _d = _a.options, options = _d === void 0 ? [] : _d, _e = _a.primaryTextKey, primaryTextKey = _e === void 0 ? 'primaryKey' : _e, _f = _a.secondaryTextKey, secondaryTextKey = _f === void 0 ? 'secondaryKey' : _f, _g = _a.rowId, rowId = _g === void 0 ? "id" : _g, _h = _a.selectedIdList, selectedIdList = _h === void 0 ? [] : _h, children = _a.children, _j = _a.updateOrder, updateOrder = _j === void 0 ? function (_updatedOrder) { } : _j;
    var _k = __read((0, react_1.useState)(options), 2), OptionsList = _k[0], setOptionsList = _k[1];
    var _l = __read((0, react_1.useState)(selectedIdList || []), 2), selectedLists = _l[0], setSelectedLists = _l[1];
    var _m = __read((0, react_1.useState)(null), 2), focusedIndex = _m[0], setFocusedIndex = _m[1];
    var _o = __read((0, react_1.useState)(null), 2), draggingIndex = _o[0], setDraggingIndex = _o[1];
    var _p = __read((0, react_1.useState)(null), 2), activeId = _p[0], setActiveId = _p[1];
    var cardRefs = (0, react_1.useRef)([]);
    var childrenArray = react_1.Children.toArray(children);
    var selectedListsOnLoad = options
        .filter(function (item) { return item.isToggleSelected; })
        .map(function (item) { return item.id; });
    var filteredStrings = selectedListsOnLoad.filter(function (item) { return typeof item === 'string'; });
    onInitialLoad(filteredStrings, options);
    var sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.MouseSensor, {
        activationConstraint: {
            distance: 0,
        },
    }), (0, core_1.useSensor)(core_1.KeyboardSensor, {
        coordinateGetter: sortable_1.sortableKeyboardCoordinates,
        scrollBehavior: 'auto',
    }));
    var getIndex = function (id) {
        return variant === 'settings'
            ? OptionsList.findIndex(function (item) { return item.id === id; })
            : childrenArray.findIndex(function (child) { return (0, react_1.isValidElement)(child) && child.props.id === id; });
    };
    var handleDragEnd = function (event) {
        var _a;
        var active = event.active, over = event.over;
        setActiveId(null);
        if (active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
            var oldIndex = getIndex(active.id);
            var newIndex = getIndex((_a = over === null || over === void 0 ? void 0 : over.id) !== null && _a !== void 0 ? _a : '');
            if (variant === 'settings') {
                var newOrder = (0, sortable_1.arrayMove)(OptionsList, oldIndex, newIndex);
                setOptionsList(newOrder);
                updateChangeValue(newOrder);
            }
            else {
                var currentOrder = getOrderIdForChildren();
                var newOrder = (0, sortable_1.arrayMove)(currentOrder, oldIndex, newIndex);
                updateOrder(newOrder);
            }
        }
        setDraggingIndex(null);
    };
    var handleSwitchClick = function (event, index) {
        if (event && typeof event.stopPropagation === 'function') {
            event.stopPropagation();
        }
        handleToggleOn(event, index);
    };
    var handleDragStart = function (event) {
        var active = event.active;
        setActiveId(String(active.id));
        var index = getIndex(active.id);
        if (index !== -1) {
            setDraggingIndex(index);
        }
    };
    var handleKeyDown = function (event, index) {
        switch (event.key) {
            case 'ArrowUp':
                event.preventDefault();
                if (index > 0) {
                    var newOrder = (0, sortable_1.arrayMove)(OptionsList, index, index - 1);
                    setOptionsList(newOrder);
                    setFocusedIndex(index + 2);
                    updateChangeValue(newOrder);
                }
                break;
            case 'ArrowDown':
                event.preventDefault();
                if (index < OptionsList.length - 2) {
                    var newOrder = (0, sortable_1.arrayMove)(OptionsList, index, index + 1);
                    setOptionsList(newOrder);
                    setFocusedIndex(index + 1);
                    updateChangeValue(newOrder);
                }
                break;
            case 'Space':
                event.preventDefault();
                setDraggingIndex(draggingIndex === null ? index : null);
                break;
            default:
                break;
        }
    };
    var handleToggleOn = function (event, index) {
        var _a, _b;
        if (event) {
            (_a = event.preventDefault) === null || _a === void 0 ? void 0 : _a.call(event);
            (_b = event.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(event);
        }
        var updatedList = OptionsList.map(function (item, i) {
            if (i === index) {
                return __assign(__assign({}, item), { isToggleSelected: !item.isToggleSelected });
            }
            return item;
        });
        setOptionsList(updatedList);
        updateChangeValue(updatedList);
    };
    var getOrderIdForChildren = function () {
        return childrenArray
            .filter(function (child) {
            return (0, react_1.isValidElement)(child) && child.props.id;
        })
            .map(function (child) { return child.props.id; });
    };
    var getItemsForSortableContext = function () {
        if (variant === 'flexible') {
            return getOrderIdForChildren();
        }
        return OptionsList.map(function (option) { return option[rowId]; });
    };
    var setSelectedListIds = function (list) {
        return list.filter(function (item) { return item.isToggleSelected; }).map(function (item) { return item.id; });
    };
    var updateChangeValue = function (updatedList) {
        var selectedLists = setSelectedListIds(updatedList);
        var filteredStrings = selectedLists.filter(function (item) { return typeof item === 'string'; });
        setSelectedLists(filteredStrings);
        onChangeValue(filteredStrings, updatedList);
    };
    return (react_1.default.createElement(core_1.DndContext, { collisionDetection: core_1.closestCenter, onDragEnd: handleDragEnd, onDragStart: handleDragStart, modifiers: [modifiers_1.restrictToVerticalAxis, modifiers_1.restrictToFirstScrollableAncestor], sensors: sensors },
        react_1.default.createElement(sortable_1.SortableContext, { items: getItemsForSortableContext(), strategy: sortable_1.verticalListSortingStrategy },
            react_1.default.createElement(styles_1.ListElement, { role: "list" },
                variant === 'settings' &&
                    OptionsList.map(function (option, index) {
                        var isDragging = draggingIndex === index;
                        var itemLabel = "".concat(option[primaryTextKey], " ").concat(index + 1, " of ").concat(OptionsList.length);
                        var keyOption = option[rowId];
                        return (react_1.default.createElement(styles_1.DivContainer, { key: keyOption, "data-testid": "sortable-item-".concat(keyOption), "aria-grabbed": isDragging, "aria-labelledby": "sortable-item-label-".concat(keyOption), role: "listitem", "aria-describedby": isDragging
                                ? "You have grabbed ".concat(itemLabel)
                                : "".concat(itemLabel, " is draggable") },
                            react_1.default.createElement(SortableItem_1.SortableItem, { ref: function (el) { return (cardRefs.current[index] = el); }, id: keyOption, "data-testid": "sortable-item-".concat(keyOption), option: option, secondaryText: option[secondaryTextKey], primaryText: option[primaryTextKey], index: index, variant: variant, focusedIndex: focusedIndex, handleToggleOn: function (event) { return handleToggleOn(event, index); }, selectedLists: selectedLists, onKeyDown: handleKeyDown, isDragging: isDragging, handleSwitchClick: handleSwitchClick }, children)));
                    }),
                variant === 'flexible' &&
                    childrenArray.map(function (child, index) {
                        var isDisabled = (0, react_1.isValidElement)(child) && child.props.isDisabled;
                        return (react_1.default.createElement(SortableItem_1.SortableItem, { key: index, variant: variant, id: (0, react_1.isValidElement)(child) && child.props.id, index: index, ref: function (el) { return (cardRefs.current[index] = el); }, isDragging: draggingIndex === index, focusedIndex: focusedIndex, isDisabled: isDisabled }, child));
                    }))),
        react_1.default.createElement(core_1.DragOverlay, null, activeId &&
            (variant === 'settings'
                ? (function () {
                    var option = OptionsList.find(function (option) { return rowId && String(option[rowId]) === activeId; });
                    if (!option) {
                        return null;
                    }
                    var index = OptionsList.findIndex(function (item) { return rowId && String(item[rowId]) === activeId; });
                    return (react_1.default.createElement(SortableItem_1.SortableItem, { id: activeId, ref: function (el) { return (cardRefs.current[index] = el); }, option: option, "data-testid": "sortable-item-".concat(option[rowId]), handleSwitchClick: handleSwitchClick, secondaryText: option[secondaryTextKey], primaryText: option[primaryTextKey], index: index, onKeyDown: handleKeyDown, variant: variant, handleToggleOn: function (event) { return handleToggleOn(event, index); }, focusedIndex: focusedIndex, selectedLists: selectedLists, isDragging: true }, children));
                })()
                : (function () {
                    var index = getIndex(activeId);
                    return (react_1.default.createElement(SortableItem_1.SortableItem, { key: index, variant: variant, id: activeId, index: index, ref: function (el) { return (cardRefs.current[index] = el); }, isDragging: true, focusedIndex: focusedIndex }, childrenArray[index]));
                })()))));
};
exports.DraggableRows = DraggableRows;
exports.default = exports.DraggableRows;
//# sourceMappingURL=index.js.map